import { useSettings } from '../App/SettingsContext';
import { useState } from 'react';

const QuoteButton = ({ productId }) => {
  const {
    settings,
    addToQuote,
    isProductInQuote,
  } = useSettings();

  const [adding, setAdding] = useState(false);
  const added = isProductInQuote(productId);

  return (
    <div className="mctq_quote_btn">
      <button
        className="button product_type_simple"
        disabled={adding || added}
        onClick={async () => {
          if (added) return;
          setAdding(true);
          await addToQuote(productId);
          setAdding(false);
        }}
        style={{
          backgroundColor: added ? '#e5e7eb' : settings.quote_btn_bg_color,
          color: added ? '#6b7280' : settings.quote_btn_text_color,
          fontSize: settings.quote_btn_font_size + 'px',
          cursor: added ? 'not-allowed' : 'pointer',
          padding: '10px 22px',
          textDecoration: 'none',
          display: 'inline-block',
          border: '0',
          borderRadius: '0',
          lineHeight: '1.5',
          fontFamily: 'inherit'
        }}
      >
        {added ? 'Added to Quote' : settings.quote_button_customize}
      </button>

      {adding && (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div
            className="spinner"
            style={{ width: '20px', height: '20px', borderWidth: '2px', marginTop: '1em' }}
          />
        </div>
      )}
    </div>
  );
};

export default QuoteButton;
